export default __webpack_public_path__ + "static/media/aboutimg3.caebc249.jpg";